import { Box } from "@mui/material"
import { styled } from "@mui/material/styles"
import { RadioProps } from "./FormBigRadioButtons.interfaces"

export const StyledRadioBox = styled(Box)<RadioProps>(({ theme, isSelected }) => ({
  boxShadow: "1px 3px 3px 0px rgba(0, 0, 0, 0.10)",
  padding: "30px 15px",
  cursor: "pointer",
  borderRadius: "5px",
  display: "flex",
  alignItems: "start",
  backgroundColor: theme.palette.background.paper,
  border: isSelected ? `2px solid ${theme.palette.primary["main"]}` : "2px solid transparent"
}))
